import type { FirebaseOptions } from 'firebase/app';

const REQUIRED = [
  ['VITE_FIREBASE_API_KEY', 'apiKey'],
  ['VITE_FIREBASE_AUTH_DOMAIN', 'authDomain'],
  ['VITE_FIREBASE_PROJECT_ID', 'projectId'],
  ['VITE_FIREBASE_STORAGE_BUCKET', 'storageBucket'],
  ['VITE_FIREBASE_MESSAGING_SENDER_ID', 'messagingSenderId'],
  ['VITE_FIREBASE_APP_ID', 'appId'],
] as const;

export function readFirebaseConfig(env: Record<string, string | undefined>): FirebaseOptions {
  const out: Record<string, string> = {};
  for (const [envKey, optKey] of REQUIRED) {
    const v = env[envKey];
    if (!v) throw new Error(`Missing Firebase config: ${envKey} (copy .env.example to .env.local)`);
    out[optKey] = v;
  }
  if (env.VITE_FIREBASE_MEASUREMENT_ID) out.measurementId = env.VITE_FIREBASE_MEASUREMENT_ID;
  return out as FirebaseOptions;
}
